document
	.querySelectorAll<HTMLElement>('section.complexAccordion')
	.forEach(accordion => {
		accordion.querySelectorAll<HTMLElement>('.accordion-item').forEach(item => {
			const heading = item.querySelector('section.titleBlock')
			const copy = item.querySelector('.content-section')
			if (!heading || !copy) return

			copy.setAttribute('style', `--height: ${copy.scrollHeight}px;`)

			heading.addEventListener('click', () => {
				const cl = item.classList
				console.log(cl)
				if (cl.contains('active')) {
					cl.remove('active')
					cl.add('inactive')
					return
				}

				cl.remove('active')
				cl.add('inactive')
				copy.setAttribute('style', `--height: ${copy.scrollHeight}px;`)
				cl.add('active')
				cl.remove('inactive')

				updateURLFragment(item)
			})
		})
	})

activateAccordionsByHash()
addEventListener('hashchange', () => activateAccordionsByHash())

function updateURLFragment(item: HTMLElement) {
	const itemHash = item.getAttribute('id')
	const hashValue = window.location.hash

	//update hashvalue to accordion active id
	if (!hashValue || hashValue.substring(1) !== itemHash) {
		history.pushState(null, '', `#${itemHash}`)
		activateAccordionsByHash()
	}
}

function activateAccordionsByHash() {
	const hashValue = window.location.hash.replace(/^#/, '')
	if (!hashValue) {
		activateFirstAccordion()
		return
	}
	const fragmentAccordion = getAccordionItemById(hashValue)

	if (!fragmentAccordion) {
		// This causes weird behavior on pages that have anchorable sections besides just the accordions
		// Commenting it out rather than deleting it in case we need to revisit this and rewrite the code to work properly rather than just removing it
		// activateFirstAccordion()
		return
	}

	// deactivateAllNavItems()

	fragmentAccordion.classList.add('active')
	fragmentAccordion.classList.remove('inactive')

	const navItem = document.querySelector(`[data-slug="${hashValue}"]`)
	navItem?.classList.add('active')
	navItem?.classList.remove('inactive')
}

function activateFirstAccordion() {
	const activeNav = document.querySelector<HTMLAnchorElement>(
		'.sidebar .sidebar-link'
	)

	if (activeNav) {
		if (activeNav.dataset.slug) {
			const accordion = getAccordionItemById(activeNav.dataset.slug)
			if (accordion) {
				accordion.classList.add('active')
				accordion.classList.remove('inactive')
			}
		}
	}
}

function getAccordionItemById(id: string) {
	let fragmentAccordion = document.querySelector<HTMLElement>('#' + id)
	// If the targeted id is on a child of an accordion item, find the parent accordion item
	if (!fragmentAccordion?.classList.contains('accordion-item')) {
		fragmentAccordion =
			fragmentAccordion?.closest<HTMLElement>('.accordion-item') ?? null
	}

	return fragmentAccordion
}

function deactivateAllNavItems() {
	const activeNavItems = document.querySelectorAll<HTMLAnchorElement>(
		'.accordion-item.active'
	)

	activeNavItems.forEach(item => {
		item.classList.remove('active')
		item.classList.add('inactive')
	})
}
